function compare_button_click(){
    // Get all elements with the class 'card-compare-button' and add click event listeners
    const compareButtons = document.querySelectorAll('.card-compare-button');
    
    compareButtons.forEach(button => {
        button.addEventListener('click', (event) => {
            // Get the product type from the 'data-product-type' attribute of the button
            const productType2 = {
                product_type:button.getAttribute('data-product-type')
            };
            const productType = productType2.product_type
            localStorage.setItem('product_type', JSON.stringify(productType2));
            let compareProductList = localStorage.getItem('compareProductList') ? JSON.parse(localStorage.getItem('compareProductList')) : {};
            
            // If the productType is not present in the compareProductList, initialize it as an empty array
            if (!compareProductList[productType]) {
                compareProductList[productType] = [];
            }
            
            if (compareProductList[productType].length < 4) {
                // Get the current product's details
                const variant_content = button.querySelector('.product-variant').innerHTML;
                const data_phase_change_material = button.querySelector('.product-variant').getAttribute('data-phase_change_material');
                const data_product_title = button.querySelector('.product-variant').getAttribute('data-product-title');
                const data_product_best_for = button.querySelector('.product-variant').getAttribute('data-product-best_for');
                const data_product_body_weight = button.querySelector('.product-variant').getAttribute('data-product-body_weight');
                const data_sleep_position = button.querySelector('.product-variant').getAttribute('data-sleep_position');
                
                // Parse the variant content into an object
                const variantObject = JSON.parse(variant_content);
                
                // Create a product object
                const product_current = {
                    ...variantObject,
                    phase_change_material: data_phase_change_material,
                    product_title: data_product_title,
                    best_for: data_product_best_for,
                    body_weight: data_product_body_weight,
                    sleep_position: data_sleep_position
                };

                let isHasId = false;
                
                // Check if the product already exists in the compareProductList for the given productType
                compareProductList[productType].forEach((product, index) => {
                    if (product.id === product_current.id) {
                        console.log('产品已存在于对比列表中:', product);
                        product = product_current; // If the product exists, replace it
                        isHasId = true;
                    }
                });
                
                // If the product does not exist, add it to the list
                if (!isHasId) {
                    console.log('产品添加到对比列表中:', product_current);
                    compareProductList[productType].push(product_current);
                }
                
                // Save the updated compareProductList to localStorage
                localStorage.setItem('compareProductList', JSON.stringify(compareProductList));
                
                // Dispatch a custom event to notify other parts of the application
                const compareEvent = new CustomEvent('compareProductListUpdated', {
                    detail: compareProductList[productType]
                });
                document.dispatchEvent(compareEvent);
            } else {
                // If there are already 4 products in the compare list for the current type, dispatch event with null to clear
                const compareEvent = new CustomEvent('compareProductListUpdated', {
                    detail: compareProductList[productType]   
                });
                document.dispatchEvent(compareEvent);
            }
        });
    });
}

compare_button_click();